import { render, staticRenderFns } from "./opportunity.vue?vue&type=template&id=7a1d78bf&scoped=true"
import script from "./opportunity.vue?vue&type=script&lang=js"
export * from "./opportunity.vue?vue&type=script&lang=js"
import style0 from "./opportunity.vue?vue&type=style&index=0&id=7a1d78bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d78bf",
  null
  
)

export default component.exports